import { defineComponent as _defineComponent } from 'vue';
import { BTab, BTabs } from "bootstrap-vue";
import { computed, ref } from "vue";
import { useConfigurationTemplateEdit } from "@/components/ConfigTemplates/useConfigurationTesting";
import { useInstanceAndTemplate } from "./instance";
import { useInstanceRouting } from "./routing";
import EditSecrets from "./EditSecrets.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditInstance',
    props: {
        instanceId: null
    },
    setup(__props) {
        const props = __props;
        const editTestUrl = "/api/file_source_instances/{uuid}/test";
        const editUrl = "/api/file_source_instances/{uuid}";
        const { instance, template } = useInstanceAndTemplate(ref(props.instanceId));
        const title = computed(() => { var _a, _b; return `Edit ${(_a = template.value) === null || _a === void 0 ? void 0 : _a.name} settings for ${(_b = instance.value) === null || _b === void 0 ? void 0 : _b.name}`; });
        const errorDataDescription = "file-source-update-error";
        const { error, hasSecrets, ActionSummary, inputs, InstanceForm, loadingMessage, onForceSubmit, onSubmit, testRunning, testResults, submitTitle, showForceActionButton, } = useConfigurationTemplateEdit("file source", instance, template, editTestUrl, editUrl, useInstanceRouting);
        return { __sfc: true, editTestUrl, editUrl, props, instance, template, title, errorDataDescription, error, hasSecrets, ActionSummary, inputs, InstanceForm, loadingMessage, onForceSubmit, onSubmit, testRunning, testResults, submitTitle, showForceActionButton, BTab, BTabs, EditSecrets };
    }
});
